<template>
    <h1 class="text-2xl">
        <slot></slot>
    </h1>
</template>

<script>
export default {
    props: {
    },
};
</script>
